import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { KPI } from '../api';
import { INSIGHT_GLOBAL_FILTER_STORAGE_KEY } from './constants';

@Injectable()
export class InsightFiltersService {

    private _selectedGlobalFilter$ = new BehaviorSubject<number>(null);
    private cachedSelectedGlobalFilterLoaded: boolean = false;

    constructor() { }

    public get selectedGlobalFilter$(): Observable<number> {
        if (!this.cachedSelectedGlobalFilterLoaded) {
            const cachedFilter = localStorage.getItem(
                INSIGHT_GLOBAL_FILTER_STORAGE_KEY,
            );
            if (cachedFilter) {
                this._selectedGlobalFilter$.next(Number(cachedFilter));
            } else {
                this._selectedGlobalFilter$.next(KPI.InsightGlobalFilter.ONLY_PLANNED_INVESTMENTS);
            }
            this.cachedSelectedGlobalFilterLoaded = true;
        }
        return this._selectedGlobalFilter$;
    }

    public setSelectedGlobalFilter(filterId: number): void {
        if (filterId !== this._selectedGlobalFilter$.value) {
            this._selectedGlobalFilter$.next(filterId);
            localStorage.setItem(
                INSIGHT_GLOBAL_FILTER_STORAGE_KEY,
                filterId.toString(),
            );
        }
    }

}
